import { FC, useEffect } from "react";
import Details from "../details";
import { useForm } from "react-hook-form";
import { getStaticTexts } from "../../../constants";
import { CustomDialog } from "../../../components";
import { useSelector } from "react-redux";

interface props {
  isOpen: boolean;
  type: "new" | "edit" | "view";
  report: any;
  onClose: () => void;
  userType: "reportedUser" | "reportedBy";
}

const Manage: FC<props> = ({ isOpen, type, report, userType, onClose }) => {
  const isDisabled = type === "view" ? true : false;

  const language = useSelector((state: any) => state.profile.defaultLanguage);
  const staticTexts = getStaticTexts(language);

  const user =
    userType === "reportedUser" ? report?._reportedUser : report?._reportedBy;

  const { setValue } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      prefix: "",
      profile: "",
      coverProfile: "",
      address: "",
      description: "",
    },
  });

  useEffect(() => {
    if (type === "view" || type === "edit") {
      setValue("prefix", `+${user?.phone?.prefix}`);
      setValue("phone", user?.phone?.number);
      setValue("name", user?.name);
      setValue("email", user?.email);
      setValue("profile", user?.profile);
    }
  }, [type, user]);

  return (
    <CustomDialog
      title={staticTexts.reportDetail}
      isOpen={isOpen}
      onClose={onClose}
      disabled={isDisabled}
      customStyles={{
        "& .css-gewopa": {
          boxShadow: "none",
          padding: "0px",
        },
      }}
    >
      {type === "view" && <Details report={report} />}
    </CustomDialog>
  );
};

export default Manage;
